import React from 'react';
import { Modal, Box, IconButton } from '@mui/joy';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Modal for displaying fullscreen image or PDF preview
 */
const FullscreenImageModal = ({
  open,
  onClose,
  testPage
}) => {
  if (!open || !testPage) return null;

  const isPdf = testPage.file?.type?.includes('pdf');

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableScrollLock
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        data-testid="fullscreen-preview-surface"
        sx={{
          position: 'relative',
          backgroundColor: 'background.surface',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 'lg',
          padding: 2,
          width: '90vw',
          height: '90vh',
          overflow: 'auto',
        }}
      >
        {/* Close Button */}
        <IconButton
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 1,
            backgroundColor: 'neutral.softBg',
            color: 'text.primary',
            '&:hover': {
              backgroundColor: 'neutral.softHoverBg',
            }
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        {/* Modal Content */}
        {isPdf ? (
          <iframe
            src={`${testPage.url}#zoom=200`}
            style={{
              height: '100%',
              width: '100%',
              border: 'none',
              display: 'block',
            }}
            title="PDF Viewer"
          />
        ) : (
          <img
            src={testPage.url}
            alt={testPage.name}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        )}
      </Box>
    </Modal>
  );
};

export default FullscreenImageModal;
